

const state_temp={messages:[{ role: 'bot', 
content: 'Hello, welcome. How may i help you today?' }], UIstates:{}}


const  reducer=(state=state_temp, action)=>{

switch(action.type)

{

case 'add_message':

var added_messages=state.messages.concat([action.payload])
    return {...state, messages:added_messages}



default:
    return state



}
}

export default reducer